import { FACEBOOK_PIXEL_ID, FACEBOOK_SCRIPT_ID } from './tracking.constants';

let isFacebookPixelInitialized = false;

const injectOfficialFacebookSnippet = () => {
	if (document.getElementById(FACEBOOK_SCRIPT_ID)) {
		return;
	}

	const script = document.createElement('script');
	script.id = FACEBOOK_SCRIPT_ID;
	script.textContent = `
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init','${FACEBOOK_PIXEL_ID}');
fbq('track','PageView');
`;
	document.head.appendChild(script);

	const noscript = document.createElement('noscript');
	noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${FACEBOOK_PIXEL_ID}&ev=PageView&noscript=1" alt="" />`;
	document.body.appendChild(noscript);
};

export const initFacebookPixel = () => {
	if (isFacebookPixelInitialized) {
		return;
	}

	injectOfficialFacebookSnippet();
	isFacebookPixelInitialized = true;
};

export const fireFacebookEvent = (eventName, eventData = {}) => {
	if (typeof window.fbq !== 'function') {
		return;
	}

	window.fbq('track', eventName, eventData);
};
